import controller from './escalations.controller';

const template = require('./escalations.html');

export default {
    controller,
    template,
    bindings: {
        organizationId: '<',
        contactGroups: '<',
        escalationTemplates: '<',
        onEscalationTemplatesChange: '&',
    }
};
